import { ArrowUpRight } from "@phosphor-icons/react";
import { SiteBrand } from "./SiteBrand";

const LINKS = [
  { l: "Home", h: "https://www.diotech.it/" },
  { l: "Chi siamo", h: "https://www.diotech.it/chi-siamo/" },
  { l: "Servizi", h: "https://www.diotech.it/servizi/" },
  { l: "Contatti", h: "https://www.diotech.it/#contatti" },
];

export const SiteHeader = () => (
  <header className="dt-header" data-testid="site-header">
    <div className="dt-container h-[78px] lg:h-[91px] flex items-center justify-between gap-6">
      <SiteBrand />
      <nav className="hidden md:flex items-center gap-8" aria-label="Navigazione sito">
        {LINKS.map((x) => (
          <a key={x.l} href={x.h} className="dt-nav-link" data-testid={`site-nav-${x.l.toLowerCase().replace(" ", "-")}`}>{x.l}</a>
        ))}
      </nav>
      <a href="https://custom.teamviewer.com/6rkg6jp" target="_blank" rel="noopener noreferrer" className="dt-btn dt-btn-small" data-testid="site-remote-btn">
        <span className="hidden sm:inline">Assistenza remota</span><span className="sm:hidden">Remota</span>
        <ArrowUpRight size={16} weight="bold" />
      </a>
    </div>
    <nav className="md:hidden dt-container flex gap-6 overflow-x-auto pb-3 -mt-2 text-[13px]" aria-label="Navigazione sito mobile">
      {LINKS.map((x) => (
        <a key={x.l} href={x.h} className="dt-nav-link whitespace-nowrap" data-testid={`site-nav-mobile-${x.l.toLowerCase().replace(" ", "-")}`}>{x.l}</a>
      ))}
    </nav>
  </header>
);
